/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useMemo ,useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import PaginationBox from './PaginationBox';
import providerClaimAllDetailsPDF from './ProviderClaimAllDetailsPDF';
import providerClaimDetailsPDF from './ProviderClaimDetailsPDF';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  viewPortHeight_355,
  viewPortHeight_200,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { ProviderListTableHead, ProviderClaimTableHead } from './TableHead';
import { getProviderData, setPaginationIndex,getProviderData1 } from '../Store/action';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  NO_DATA,
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const DisplayDProviderClaim = () => {
  const { displayObj, countValue } = useSelector(
    (state) => state?.sharedState?.DProviderClaimReducer
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const {
    rebateProgramName: getRebateProgramName,
    quarterFrom: getQuarter,
    providerSelectionValue,
    providerIdValue,
    providerInfo,
    printOptionValue,
    providerGridData,
    referenceDataSelectedValue,
  } = displayObj;

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [selectedProvider, setSelectedProvider] = React.useState([]);
  var parts = referenceDataSelectedValue?.split(' | ');

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  var part1 = parts[0];
  var part2 = parts[1];

  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState();
  const [providerListData, setProviderListData] = React.useState([]);
  const [claimListData, setClaimListData] = React.useState([]);
  const [claimListRow, setClaimListRow] = React.useState([]);
  const [printOption, setPrintOption] = React.useState('Summary');
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [isTableClaimVisible, setIsTableClaimVisible] = React.useState(false);
  // pagination
  const paginationLength =
    providerSelectionValue == 'Eligible' ? 1 : providerGridData?.length;
  const [count, setCount] = React.useState(countValue);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      // if (value < 1 || value > paginationArray.length) {
      //   dispatch(setPaginationIndex(paginationArray.length));
      // } else {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));

    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    // } else {
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const Name =
    providerSelectionValue == 'Eligible'
      ? providerListData && providerListData[count - 1]?.name
      : providerGridData && providerGridData[count - 1]?.providerName;
  const id =
    providerSelectionValue == 'Eligible'
      ? providerIdValue
      : providerGridData && providerGridData[count - 1]?.providerId;

  // provider data
  React.useEffect(() => {
    let data1 = providerInfo?.providerclaimListingDetails?.detailPageGridList;
    data1 = data1?.map((item) => {
      return {
        ...item,
        numOfClaims: item.numOfClaims,
        // ? parseFloat(item.numOfClaims)?.toFixed(2)
        // : '0.00',
        totalBilled: item.totalBilled
          ? parseFloat(item.totalBilled)?.toFixed(2)
          : '0.00',
        totalPaid: item.totalPaid
          ? parseFloat(item.totalPaid)?.toFixed(2)
          : '0.00',
        totalCalculated: item.totalCalculated
          ? parseFloat(item.totalCalculated)?.toFixed(2)
          : '0.00',
        totalCalculatedPaid: item.totalCalculatedPaid
          ? parseFloat(item.totalCalculatedPaid)?.toFixed(2)
          : '0.00',
        totalRebate: item.totalRebate
          ? parseFloat(item.totalRebate?.toFixed(2))
          : '0.00',
        ura: item.ura ? parseFloat(item.ura).toFixed(4) : '0.0000',
        units: item.units ? parseFloat(item.units)?.toFixed(4) : '0.0000',
      };
    });
    setProviderListData(data1);
  }, [providerInfo]);

  // Function to calculate the sum of a property in a data array
  const sum = (data, property) => {
    if (!data || data.length === 0) {
      return '0.00';
    }

    const total = data.reduce((accumulator, object) => {
      const value = object[property] ? parseFloat(object[property]) : 0;
      return accumulator + value;
    }, 0);

    return total ? parseFloat(total.toFixed(2)) : '0.00';
  };

  // Function to create the bottom row data
  const createData = (data, propertyMappings) => {
    return [
      {
        isBottomRow: true,
        drugName: 'Total:',
        ...Object.keys(propertyMappings).reduce((acc, key) => {
          acc[key] = sum(data, propertyMappings[key]);
          return acc;
        }, {}),
      },
    ];
  };

  const providerPropertyMappings = {
    numOfClaims: 'numOfClaims',
    totalBilled: 'totalBilled',
    totalPaid: 'totalPaid',
    totalCalculated: 'totalCalculated',
    totalCalculatedPaid: 'totalCalculatedPaid',
    totalRebate: 'totalRebate',
    ura: 'ura',
    units: 'units',
  };

  const claimPropertyMappings = {
    billed: 'billed',
    paid: 'paid',
    calculated: 'calculated',
    calculatedPaid: 'calculatedPaid',
    rebate: 'rebate',
    units: 'units',
  };
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const User = userDefaults && userDefaults.userId ? userDefaults.userId : logInUser;
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const pinnedBottomRowData = useMemo(() => {
    if (!filterApply) {
      return createData(providerListData, providerPropertyMappings);
    } else {
      return createData(filteredRows, providerPropertyMappings);
    }
  }, [providerListData, filterApply, filteredRows]);
  
  const onSelectionChanged = (event) => {
    setIsTableClaimVisible(true);
    setSelectedProvider(event.api.getSelectedRows());
  };
      const [triggerExport, setTriggerExport] = React.useState(false);

  // claim list data
  React.useEffect(() => {
    let data2 = providerInfo?.providerclaimListingDetails?.detailPageDetailList;
    
    data2 = data2?.map((item) => {
      return {
        ...item,
        billed: item.billed ? parseFloat(item.billed).toFixed(2) : '$0.00',
        paid: item.paid ? parseFloat(item.paid) : '$0.00',
        calculated: item.calculated ? parseFloat(item.calculated) : '$0.00',
        calculatedPaid: item.calculatedPaid  ? parseFloat(item.calculatedPaid) : '$0.00',
        rebate: item.rebate ? parseFloat(item.rebate) : '$0.00',
        units: item.units ? parseFloat(item.units).toFixed(4) : '0.0000',
        };
    });
    let rowData = [];
    if (selectedProvider.length > 0 && data2) {
      rowData = data2.filter((item) => {
        return item.drugSeqNum == selectedProvider[0].drugSeqNum;
      });
    }
    setClaimListRow(rowData);
  }, [selectedProvider,providerInfo]);
  React.useEffect(() => {
    if (paginationLength >= 1)
      dispatch(
        getProviderData({
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          qtr: getQuarter,
          providerId:
            providerSelectionValue == 'Eligible'
              ? [providerIdValue]
              : providerGridData && [providerGridData[count - 1]?.providerId],
          providerIdTypeCd: part1,
          isInEligible: providerSelectionValue == 'Ineligible' ? 1 : 0,
        })
      );
  }, [count]);
  // provider type

  var parts = referenceDataSelectedValue?.split(' | ');
  var part1 = parts[0];
  var part2 = parts[1];
  const fetchProviderData = async () => {
    const listproviderIds = providerGridData?.map(item => item.providerId) ?? [];
    const data = await dispatch(
      getProviderData1({
        rebateProgramCd: getRebateProgramName?.rebateProgramCd,
        qtr: getQuarter,
        providerId: listproviderIds,
        providerIdTypeCd: part1,
        isInEligible: providerSelectionValue === "Ineligible" ? 1 : 0,
      })
    );
    return data; // return the fetched data
  };
React.useEffect(() => {
    setClaimListData(
      providerInfo?.providerclaimListingDetails?.detailPageDetailList
    );
  }, [providerInfo]);


 const exportInProgressRef = useRef(false);


const providerAllClaimPDFExport = async (name) => {
  if (exportInProgressRef.current) return;

  exportInProgressRef.current = true;

  try {
    const providerData = await fetchProviderData();
    const fileName = name || "ProviderClaimListing";

    providerClaimAllDetailsPDF(
      providerData,
      ProviderListTableHead,
      claimListData,
      ProviderClaimTableHead,
      userDefaults,
      getRebateProgramName,
      getQuarter,
      providerIdValue,
      fileName,
      `${id}-${Name}`,
      providerSelectionValue,
      selectedProvider,
      User,
      logInUser,
      displayObj,
      dispatch
    );
  } catch (error) {
    console.error("PDF export failed", error);
  } finally {
    exportInProgressRef.current = false;
  }
};


  const providerClaimPDFExport = () => {
    const fileName = 'ProviderClaimListing';
    providerClaimDetailsPDF(
      providerListData,
      ProviderListTableHead,
      claimListData,
      ProviderClaimTableHead,
      userDefaults,
      getRebateProgramName,
      getQuarter,
      providerIdValue,
      fileName,

      part2,
      `${id}-${Name}`,
      providerSelectionValue,
      selectedProvider,
      logInUser,
      dispatch
    );
  };

  // pdf header
  const thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  const secondInfo = `Provider ID Type: ${part2}`;
  const fourthInfo = `Provider ID : ${id} - ${Name}`;
  const firstInfo = `Provider Eligibility :${providerSelectionValue}`;
  const fifthInfo = `Quarter: ${getQuarter}`;

  return (
    <div
      id="tabs-container"
      className="tabs-contaitBillPanel custom-check tabs-container bottom-pinned-bold"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display Provider Claim Listing"
      />{' '}
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row mb-5">
              <div className="col-12">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Paid Quarter"
                        id="Paid_Quarter"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Paid_Quarter' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={getQuarter}
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Provider ID Type "
                        id="Provider_ID_Type"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Provider_ID_Type' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={part2}
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Provider ID "
                        id="Provider_ID"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Provider_ID' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={id}
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Name"
                        id="Name"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Name' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={Name}
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Provider Eligibility"
                        id="Provider_Eligibility"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Provider_Eligibility' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={providerSelectionValue}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">Print Option</legend>
                      <div className="form-wrapper p-3">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <RadioGroup
                            row
                            data-testid="provider-claim-listing-radio-option"
                            name="report-quarter"
                            required
                            value={printOption}
                            onChange={(e) => {
                              setPrintOption(e.target.value);
                              setClaimListRow([]);
                              if (gridApi) {
                                if (e.target.value === 'Detail') {
                                  gridApi.deselectAll();
                                  const firstRow = gridApi.getRenderedNodes()?.[0]||'';
                                  if (firstRow) {
                                    firstRow.setSelected(true);
                                    gridApi.ensureNodeVisible(firstRow);
                                  }
                                } else {
                                  gridApi.deselectAll();
                                }
                              }
                            }}
                          >
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="Summary"
                              control={<Radio />}
                              label="Summary"
                            />
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="Detail"
                              control={<Radio />}
                              label="Detail"
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            onSelectionChanged={onSelectionChanged}
            data-testid="Provider-Claim-Listing-1"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            providerAllClaimPDFExport={providerAllClaimPDFExport}
            fetchProviderData={fetchProviderData}
            exportAllTpPDFOne
            countValue={count}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={
              providerListData
              // printOption === 'Detail' ? providerListData : claimListData
            }
            columnDefs={
              ProviderListTableHead
              // printOption === 'Detail'
              // ? ProviderListTableHead
              // : ProviderClaimTableHead
            }
            gridCall={(params) => setGridApi(params?.api)}
            exportFile
            animateRows
            sideBar={false}
            fileName="ProviderClaimListing "
            reportName="Provider Claim Listing Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            isScrollOn
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, fourthInfo, secondInfo, thirdInfo, fifthInfo }}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            customPDFExport={
              printOption === 'Detail' ? providerClaimPDFExport : null
            }
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 18) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
        {/* {isTableClaimVisible && ( */}
        {printOption === 'Detail' && claimListRow?.length && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              data-testid="Provider-Claim-Listing-2"
              rowSelection="single"
              countValue={countValue}
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_200}
              rowData={claimListRow}
              columnDefs={ProviderClaimTableHead}
              exportFile
              animateRows
              sideBar={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              fileName="ProviderClaimListing "
              reportName="Provider Claim Listing Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ firstInfo, fourthInfo, secondInfo, thirdInfo, fifthInfo }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayDProviderClaim;
